import { Container } from '../ui/Container'
import { CTA } from '../ui/CTA'
import { Eyebrow } from '../ui/Eyebrow'
import { Reveal } from '../ui/Reveal'

export function AboutTeaser() {
  return (
    <section className="border-b border-ink/10 py-24 md:py-32">
      <Container>
        <div className="grid gap-10 md:grid-cols-2 md:gap-20">
          <Reveal>
            <Eyebrow>Company</Eyebrow>
            <h2 className="mt-6 font-display text-4xl font-semibold leading-tight tracking-tight text-balance md:text-5xl">
              We&apos;re building a technology company.
            </h2>
          </Reveal>
          <Reveal delay={150}>
            <p className="text-base leading-relaxed text-graphite">
              Limitlast began with digital services. Over time, the work revealed a larger
              opportunity. Businesses don&apos;t just need websites — they need better systems, better
              products, better information, and better ways to operate. Limitlast is evolving from a
              service-led business toward a technology company that builds digital products and
              systems for clients while developing products of its own.
            </p>
            <div className="mt-8">
              <CTA to="/about" variant="ghost">
                About Limitlast
              </CTA>
            </div>
          </Reveal>
        </div>
      </Container>
    </section>
  )
}
